import { useAuth } from '../contexts/AuthContext'

export function usePermissions() {
  return useAuth()
}
